import { DateOnly, TimeOnly } from "../Utils/DateManagement";
export type AvailabilityDto ={
    id:number;
    date:DateOnly;
    startTime:TimeOnly;
    endTime:TimeOnly;
    maxBookings:number;
    category:string;
    createdAt:Date;
    updatedAt:Date;
}
export type BookingDto = {
    id:number;
    slotId:number;
    slot:AvailabilityDto;
    applicationUserId?:string;
    name?:string;
    email?:string;
    swishTransactionID?:string;
    bankIdVerified?:boolean;
    status:BookingStatus;
    createdAt:Date;
    updatedAt:Date;
    notes:string;
    materialSent:boolean;
}
export enum BookingStatus{
    Pending,
    Confirmed,
    Cancelled,
    Material_Sent,
    Rescheduled
}
export type SlotType = {
    id: string;
    date: string;
    time: string;
    dayName: string;
    available: boolean;
    tableId:number;
  };

export type RebookProposedSlotDto = {
    id: number;
    rebookRequestId: number;
    date: string;
    startTime: string;
    endTime: string;
    source: string;
    expiresAt: string;
};

export type RebookRequestDto = {
    id: number;
    bookingId: number;
    createdAt: string;
    expiresAt: string;
    isClosed: boolean;
    status: string;
    booking?: BookingDto;
    proposedSlots: RebookProposedSlotDto[];
};
